module.exports = __webpack_public_path__ + "img/pluss_icon.43613289.svg";